/**
 * @generated SignedSource<<1a63a9516f48d7393faacf3a78e69db2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_itemSearch">;
  readonly " $fragmentType": "SharedItemTile_itemSearch";
};
export type SharedItemTile_itemSearch$key = {
  readonly " $data"?: SharedItemTile_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "557a779431cc8f6d80adfd8ef99058eb";

export default node;
